import './Regularization.scss';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';

const NomRefRgularisationNormal = ({refCra,setRefCra,refMission,nomClient,refClient,refExpert,nomExpert,refCmdClient,refIntClient,setRefIntClient, mode}) => {

    NomRefRgularisationNormal.propTypes = {
        refCra: PropTypes.any,
        refMission: PropTypes.any,
        mode: PropTypes.any,
        nomClient: PropTypes.any,
        refExpert: PropTypes.any,
        refClient: PropTypes.any,
        nomExpert: PropTypes.any,
        setRefCra: PropTypes.func,
        setRefIntClient:PropTypes.func,
        refIntClient: PropTypes.any,
        refCmdClient: PropTypes.any,
    };
    //const {device}=useWindowSize();
    const { i18n } = useTranslation();

    return (
        <>
            <div className="FrameBox0Reg">
                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf. CRA')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            value={refCra}
                            onChange={(event)=>{
                                setRefCra(event.target.value);}}
                            name="refCra"
                            disabled={mode=='readOnly'}
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf. Mission')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            value={refMission}
                            disabled
                            name="refMission"
                        />
                    </div>

                </div>

                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Nom du client')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            disabled
                            value={nomClient}
                            name="nomClient"
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf. Client')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            disabled
                            value={refClient}
                            name="refClient"
                        />
                    </div>
                </div>

                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Nom de l\'expert')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            disabled
                            value={nomExpert}
                            name="nomExpert"
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf. Expert')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            disabled
                            value={refExpert}
                            name="refExpert"
                        />
                    </div>
                </div>

                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf.Int.Client')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            // disabled
                            onChange={(event)=>{
                                setRefIntClient(event.target.value);}}
                            value={refIntClient}
                            name="refIntClient"
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Réf. Commande Client')} *</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            disabled
                            value={refCmdClient}
                            name="refCmdClient"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default NomRefRgularisationNormal;